import { batch, signal } from '@preact/signals-react'

export const isTableLoading = signal(false)
export const tableData = signal([])
export const tableFormsData = signal({})
export const isEditLoading = signal(null)

//functions

export const clearSignals = () => batch(() => {
	isTableLoading.value = false
	tableData.value = []
	tableFormsData.value = {}
	isEditLoading.value = null
})